export default "__VITE_ASSET__DAokyALA__"